import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'tipoAgendamentoPipe',
    pure: true
})

export class TipoAgendamentoPipe implements PipeTransform {

    transform(value: string, args?: any): any {

        let valorFormatado: string = '';

        if (value == 'HM') {
            valorFormatado = 'Hora Marcada';
        } else if (value == 'OC') {
            valorFormatado = 'Ordem de Chegada';
        }

        return valorFormatado;
    }

}
